import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import LoginForm from './components/Auth/LoginForm';
import AdminLayout from './components/Layout/AdminLayout';
import Dashboard from './pages/Dashboard';
import Sections from './pages/Sections';
import SectionEditor from './pages/SectionEditor';
import Homepage from './pages/Homepage';
import Users from './pages/Users';
import UserSetup from './pages/UserSetup';
import Settings from './pages/Settings';

function App() {
  console.log('Admin Portal App with CRUD rendering...');
  
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/setup" element={<UserSetup />} />
          
          {/* Protected Admin Routes */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Sections CRUD Routes */}
            <Route path="sections" element={<Sections />} />
            <Route path="sections/new" element={<SectionEditor />} />
            <Route path="sections/:id/edit" element={<SectionEditor />} />
            
            {/* Other admin routes */}
            <Route path="images" element={<div className="p-6">Images Page (Coming Soon)</div>} />
            <Route path="homepage" element={<Homepage />} />
            <Route 
              path="users" 
              element={
                <ProtectedRoute roles={['admin']}>
                  <Users />
                </ProtectedRoute>
              } 
            />
            <Route path="settings" element={<Settings />} />
          </Route>
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;